import React from "react";
import { Link } from "react-router-dom";
import EntityPage from "@/components/EntityPage";
import { useRefData } from "@/context/RefDataContext";

const MODULE_OPTIONS = [
  { value: "projects", label: "CDARK" },
  { value: "biz_projects", label: "Projects" },
  { value: "assets", label: "Assets" },
  { value: "services", label: "Services" },
  { value: "tasks", label: "Tasks" },
  { value: "issues", label: "Tickets" },
  { value: "opa_requests", label: "OPA Handle" },
  { value: "teams_users_wallets", label: "Teams, Users & Wallets" },
  { value: "all_teams_tasks", label: "All Teams Tasks" },
  { value: "all_teams_tickets", label: "All Teams Tickets" },
  { value: "approvals_opa_lead", label: "OPA Request Approvals · Team Lead" },
  { value: "approvals_opa_associate", label: "OPA Request Approvals · Team Associate" },
  { value: "approvals_project_lead", label: "Project Completion Approvals · Team Lead" },
  { value: "approvals_project_associate", label: "Project Completion Approvals · Team Associate" },
  { value: "approvals_task_lead", label: "Task Close Approvals · Team Lead" },
  { value: "approvals_task_associate", label: "Task Close Approvals · Team Associate" },
  { value: "approvals_ticket_lead", label: "Ticket Close Approvals · Team Lead" },
  { value: "approvals_ticket_associate", label: "Ticket Close Approvals · Team Associate" },
];

export default function TeamsPage() {
  const ref = useRefData();
  const refWithModules = { ...ref, modules: MODULE_OPTIONS };

  const columns = [
    {
      key: "name",
      label: "Team",
      render: (t) => (
        <Link to={`/teams/${t.id}`} className="text-white hover:text-sky-300 transition-colors" data-testid={`teams-name-${t.id}`}>
          {t.name}
        </Link>
      ),
    },
    {
      key: "team_lead_id",
      label: "Team Lead",
      render: (t) => {
        const u = (ref.users || []).find((x) => x.value === t.team_lead_id);
        return <span className="text-zinc-300 text-xs">{u?.label || "—"}</span>;
      },
    },
    {
      key: "enabled_modules",
      label: "Modules",
      render: (t) => {
        const list = t.enabled_modules;
        if (!list || list.length === 0) return <span className="text-zinc-500 text-xs">All</span>;
        const labels = list.map((m) => MODULE_OPTIONS.find((x) => x.value === m)?.label || m);
        return <span className="text-zinc-400 text-xs">{labels.join(", ")}</span>;
      },
    },
    { key: "members", label: "Members", render: (t) => <span className="text-zinc-400 text-xs">{(t.members || []).length}</span> },
  ];

  const fields = [
    { key: "name", label: "Team Name", required: true },
    { key: "email", label: "Team Email", type: "email" },
    { key: "team_lead_id", label: "Team Lead", type: "select", optionsRef: "users" },
    { key: "enabled_modules", label: "Enabled Modules (leave empty for All)", type: "multiselect", optionsRef: "modules", full: true },
    { key: "members", label: "Members", type: "multiselect", optionsRef: "users", full: true },
  ];

  const initial = { name: "", email: "", team_lead_id: "", enabled_modules: [], members: [] };

  return (
    <EntityPage
      title="Teams"
      subtitle="Groups that own projects, tasks and tickets. Set a Team Lead and the modules visible to its members."
      testidPrefix="teams"
      endpoint="/teams"
      columns={columns}
      fields={fields}
      initialForm={initial}
      referenceData={refWithModules}
    />
  );
}
